let loaded = false

export function setSiftUserId(userId) {
  if (process.env.VUE_APP_SIFT_ENABLED !== 'true') {
    return
  }
  if (!userId) {
    return
  }

  window._sift = window._sift || []
  window._sift.push(['_setUserId', userId])
}

export function initSift(userId) {
  if (process.env.VUE_APP_SIFT_ENABLED !== 'true') {
    return
  }

  if (loaded) {
    return
  }

  window._sift = window._sift || []

  const interval = setInterval(() => {
    if (typeof window._sift.push === 'function') {
      window._sift.push(['_setAccount', process.env.VUE_APP_SIFT_ACCOUNT_ID])

      if (process.env.VUE_APP_SIFT_BEACON_KEY) {
        window._sift.push(['_setBeaconKey', process.env.VUE_APP_SIFT_BEACON_KEY])
      }

      if (userId) {
        window._sift.push(['_setUserId', userId])
      }

      window._sift.push(['_trackPageview'])

      clearInterval(interval)
    }
  }, 100)

  const scriptAlreadyPresent = !!document.querySelector('script[src*="sift.com/s.js"]')
  if (!scriptAlreadyPresent) {
    const s = document.createElement('script')
    s.async = true
    s.src = 'https://cdn.sift.com/s.js'

    document.head.appendChild(s)
  }

  loaded = true
}

export function trackPage() {
  if (process.env.VUE_APP_SIFT_ENABLED !== 'true') {
    return
  }

  window._sift?.push(['_trackPageview'])
}

export function trackEvent(eventName, eventData = {}) {
  if (process.env.VUE_APP_SIFT_ENABLED !== 'true') {
    return
  }

  if (!eventName) {
    return
  }

  window._sift?.push(['_trackEvent', eventName, eventData])
}

export function getSiftSessionId() {
  const names = ['s', 'sift_session', 'siftSessionId']
  const cookies = document.cookie.split(';').map(c => c.trim())
  for (const n of names) {
    const hit = cookies.find(c => c.startsWith(n + '='))
    if (hit) {
      const sessionId = decodeURIComponent(hit.split('=')[1])
      return sessionId
    }
  }
  return null
}